// extracted by mini-css-extract-plugin
module.exports = {"selectedDetail":"TableSelectionCount_selectedDetail__VWFeV","info":"TableSelectionCount_info__2Le6X","clean":"TableSelectionCount_clean__1OGRc"};